module.exports = __webpack_public_path__ + "img/上传背景.b960c00d.png";